<template>
  <div class="form-group"
    v-bind:class="{'has-error': errors.first(field.key)}">
    <p class="scroll-box-title" v-html="sanitizedAdditionalText"></p>
    <div @scroll="onScroll" class="form-scroll-box scroll-box-radio" v-html="sanitizedHelpText"></div>
    <div class="custom-control custom-radio">
      <small class="label" v-html="sanitizedFieldTitle"></small>
      <label class="form-item-group form-item-radio"
        v-for="option in field.options"
        v-bind:key="option.value">
        <input type="radio"
          :disabled=disabled
          class="custom-control-input"
          v-bind:name="field.key"
          v-bind:value="option.value"
          v-bind:checked="value === option.value"
          v-on:change="$emit('input', $event.target.value)"
          v-validate="validationRules"
          v-bind:data-vv-as="strippedFieldTitle"
          tabindex="1">
        <span class="custom-control-label">
          {{ option.title }}
        </span>
        <small class="label" v-html="option.help_text"></small>
      </label>
      <span class="invalid-feedback"
        v-if="errors.has(field.key)">
        {{ errors.first(field.key) }}
      </span>
    </div>
  </div>
</template>

<script>
import InputMixin from '@/mixins/InputMixin';

/**
 * A field that renders a scroll box and a list of radio inputs.
 */
export default {
  name: 'ScrollBoxRadio',
  mixins: [
    InputMixin,
  ],
  data() {
    return {
      disabled: true,
    };
  },
  methods: {
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      // When zoomed in Chrome, somehow scrollTop will have decimals, and make it 1px less.
      // scrollTop+clientHeight will become little less then scrollHeight.
      // add 5px to scrollTop + clientHeight, to make sure they are larger then scrollHeight
      if (scrollTop + clientHeight + 5 >= scrollHeight) {
        this.disabled = false;
      }
    },
  },
};
</script>
